import { Injectable } from '@angular/core';
import { SnackService } from './snack.service';
import { HttpClient } from '@angular/common/http';
import { serverurl } from '../../environments/environment';
import { StreamSummaryComponent } from '../home/user-report/stream-summary/stream-summary.component';
import { StreamSummary } from '../interfaces/report';
import { TokenUsageByStream } from '../lib/interfaces/generic-streams';

@Injectable({
    providedIn: 'root'
})
export class StreamreportService {

    constructor(
        private http: HttpClient,
        private snack: SnackService
    ) { }

    async getStreamReports(offset: number | null): Promise<any[] | false> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/dashboard/report/${offset}`).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async getStreamSummary(): Promise<false | StreamSummary[]> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/dashboard/stream-summary`).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async getTokenSummary(): Promise<false | TokenUsageByStream[]> {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/dashboard/token-summary`).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

}
